import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

const Footer = () => {
  const { t } = useTranslation()
  return (
    <footer className="w-full mt-20">
      <div className=" flex flex-col md:flex-row md:justify-between md:items-start border-t-[4px] b-tomato mx-auto md:max-w-[1200px] w-10/12 max-w-[400px] py-12 [&>*]:mb-20 ">
        <img
          src="/images/building-resilience.png"
          alt="Building resilience"
          title="Building resilience image"
        />
        <a
          href="https://digitaldefenders.org"
          target="_blank"
          rel="noreferrer nofollow"
          alt="Digital Defenders Partnership"
          class="mx-auto"
        >
          <img
            src="/images/ddp-logo-green.png"
            alt="Digital Defenders Partnership"
            title="Digital Defenders Partnership"
          />
        </a>
        <div class="md:text-right text-sm text-dark-sage flex flex-col items-start md:items-end justify-start md:w-1/3">
          <img
            src="/images/80x15.png"
            alt="Digital Defenders Partnership"
            title="Digital Defenders Partnership"
            class="mb-2"
          />
          <div></div>
          {t("license")}
        </div>
      </div>
    </footer>
  )
}

export default Footer
